// src/utils/securityUtils.ts

/**
 * Simple utility to disable inspection tools
 * - Prevents right-click context menu
 * - Blocks DevTools keyboard shortcuts
 * - Doesn't interfere with normal application functionality
 */

export const initializeSecurityMeasures = (): void => {
  // Only apply in production environment
  if (process.env.NODE_ENV === 'production') {
    // Disable right-click context menu
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    }, { capture: true });
    
    // Disable keyboard shortcuts for developer tools
    document.addEventListener('keydown', (e) => {
      // F12 key
      if (e.key === 'F12' || e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+I / Cmd+Option+I (Open DevTools)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.keyCode === 73)) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+J / Cmd+Option+J (Open Console)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'J' || e.key === 'j' || e.keyCode === 74)) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+C / Cmd+Option+C (Inspector)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'C' || e.key === 'c' || e.keyCode === 67)) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+U / Cmd+Option+U (View Source)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'U' || e.key === 'u' || e.keyCode === 85)) {
        e.preventDefault();
        return false;
      }
    }, { capture: true });

    // Disable drag and drop to prevent inspecting dragged elements
    document.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    }, { capture: true });
  }
};

export default {
  initialize: initializeSecurityMeasures
};
